(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haunt-import-preview"] && !Shopify.designMode) return;
  try {
    +(()=>{function init(scope=document){scope.querySelectorAll('[data-hi-product]:not([data-hi-ready])').forEach(root=>{root.dataset.hiReady='true';const main=root.querySelector('[data-hi-main]'),select=root.querySelector('[data-hi-variant]'),price=root.querySelector('[data-hi-price]'),buttons=[...root.querySelectorAll('[data-hi-image]')];function show(src,alt){main.src=src;main.alt=alt;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hiImage===src)));}buttons.forEach(b=>b.addEventListener('click',()=>show(b.dataset.hiImage,b.dataset.hiAlt)));select.addEventListener('change',()=>{const o=select.selectedOptions[0];price.textContent=o.dataset.price;show(o.dataset.image,o.dataset.alt);});root.querySelectorAll('.hi-description a[href^="/collections/"]').forEach(a=>{a.href='/?view=haunt-'+a.getAttribute('href').split('/').pop();});});}init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haunt-parallax"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haunt-parallax')) {
  class HauntParallax extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = this;
      const scene = root.querySelector('.hp-scene');
      const landscape = root.querySelector('.hp-landscape');
      const copy = root.querySelector('.hp-copy');
      const back = root.querySelector('.hp-haze-back');
      const front = root.querySelector('.hp-haze-front');
      const leaves = root.querySelector('.hp-leaves');
      const whisper = root.querySelector('.hp-whisper');
      const motion = root.querySelector('.hp-motion');
      const status = root.querySelector('.hp-announcement');
      const video = root.querySelector('video');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches || root.dataset.motionEnabled !== 'true';
      let active = true, progress = 0, target = 0, px = 0, py = 0, tx = 0, ty = 0, demoStart = 0;
      const clamp = n => Math.max(0, Math.min(1, n));
      const paint = () => {
        const p = paused ? 0 : progress, x = paused ? 0 : px, y = paused ? 0 : py;
        landscape.style.transform = `translate3d(${-x * 8}px,${p * 30 - y * 6}px,0) scale(${1.04 + p * .055})`;
        copy.style.transform = `translate3d(${x * 4}px,${p * -43 + y * 3}px,0)`;
        back.style.transform = `translate3d(${p * -50 + x * 12}px,${p * -20}px,0)`;
        front.style.transform = `translate3d(${p * 95 + x * 25}px,${p * -75}px,0)`;
        leaves.style.transform = `translate3d(${p * -26 + x * 23}px,${p * -110 + y * 14}px,0)`;
        whisper.style.transform = `translate3d(${x * 9}px,${p * -66}px,0) rotate(-6deg)`;
      };
      const tick = now => {
        this.frame = 0;
        if (paused || !active) { paint(); return; }
        if (demoStart) {
          const t = Math.min(1, (now - demoStart) / 4200);
          target = Math.sin(t * Math.PI) * .95;
          if (t === 1) { demoStart = 0; target = scrollProgress(); status.textContent = root.dataset.labelComplete; }
        }
        progress += (target - progress) * .075;
        px += (tx - px) * .08; py += (ty - py) * .08;
        paint();
        if (demoStart || Math.abs(target - progress) > .001 || Math.abs(tx - px) > .001 || Math.abs(ty - py) > .001) wake();
      };
      const wake = () => { if (!this.frame) this.frame = requestAnimationFrame(tick); };
      const scrollProgress = () => clamp(-scene.getBoundingClientRect().top / Math.max(400, scene.offsetHeight));
      const labels = () => {
        motion.setAttribute('aria-pressed', String(paused));
        motion.setAttribute('aria-label', paused ? root.dataset.labelEnable : root.dataset.labelPause);
        motion.querySelector('.hp-motion-label').textContent = paused ? root.dataset.labelOff : root.dataset.labelOn;
        motion.querySelector('.hp-toggle-icon').textContent = paused ? '▷' : 'Ⅱ';
        if (video) { if (paused || !active) video.pause(); else video.play().catch(() => {}); }
      };
      window.addEventListener('scroll', () => {
        if (paused || !active) return;
        demoStart = 0; target = scrollProgress(); wake();
      }, { passive: true, signal });
      window.addEventListener('resize', () => { target = scrollProgress(); wake(); }, { passive: true, signal });
      scene.addEventListener('pointermove', e => {
        if (paused || e.pointerType === 'touch') return;
        const r = scene.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - .5; ty = (e.clientY - r.top) / r.height - .5; wake();
      }, { passive: true, signal });
      scene.addEventListener('pointerleave', () => { tx = ty = 0; wake(); }, { signal });
      root.querySelector('.hp-demo').addEventListener('click', () => {
        if (reduced.matches) { status.textContent = root.dataset.labelReduced; return; }
        paused = false; labels(); demoStart = performance.now(); status.textContent = root.dataset.labelDemo; wake();
      }, { signal });
      root.querySelector('.hp-scroll').addEventListener('click', () => {
        const section = root.closest('.shopify-section');
        const next = section && section.nextElementSibling;
        if (next) next.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      }, { signal });
      motion.addEventListener('click', () => {
        paused = !paused; demoStart = 0; target = scrollProgress(); labels();
        status.textContent = paused ? root.dataset.labelOff : root.dataset.labelOn; wake();
      }, { signal });
      reduced.addEventListener('change', e => { paused = e.matches || root.dataset.motionEnabled !== 'true'; demoStart = 0; labels(); wake(); }, { signal });
      this.observer = new IntersectionObserver(entries => {
        active = entries[0].isIntersecting;
        if (!active) { demoStart = 0; cancelAnimationFrame(this.frame); this.frame = 0; }
        else { target = scrollProgress(); wake(); }
        labels();
      });
      this.observer.observe(scene);
      target = scrollProgress(); labels(); paint(); wake();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0; this.controller = null;
    }
  }
  customElements.define('haunt-parallax', HauntParallax);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
